const toFloat = (num) => {
  return Number(num.toPrecision(13));
};
const isDividable = (num, step) => {
  const result = toFloat(num % step);
  return result === 0 || result === step;
};
export {
  isDividable as i,
  toFloat as t
};
//# sourceMappingURL=to-float.js.map
